module.exports = __webpack_public_path__ + "static/media/dataaccess.aaa20300.svg";